const IRReducer = (state = {}, action) => {
    switch (action.type) {
        case "IRLIST_DOCS":
            return Object.assign({}, state, {
                IR_ListView: action.data
            });
        case "IREDIT_DOCS":
            return Object.assign({}, state, {
                geteditir: action.data
            });
        case "SHARE_IR_ATTACH_FILE":
            return Object.assign({}, state, {
                sharedirattachfile: action.data
            });
        case "SHARE_IR_ATTACH_PHOTO":
            return Object.assign({}, state, {
                sharedirattachphoto: action.data
            });
        case "SHARE_IRDATAS":
            return Object.assign({}, state, {
                sharedirdata: action.data
            });
        case "ERROR_IRFILES":
            return Object.assign({}, state, {
                errorirpass: action.data
            });
        default:
            return state;
    }
};

export default IRReducer;